/**
 * Structural thickness a wall label falls back to when the wall has no
 * assembly yet, matching `RealThicknessWallsMesh`'s footprint fallback.
 */
export const FALLBACK_WALL_THICKNESS = 0.2

export const BEAM_LABEL_BORDER_WIDTH = 0.005

/** Lifts beam labels off the floorplan geometry */
export const BEAM_LABEL_Z_OFFSET = 0.03

/**
 * Wall labels replace camera-facing sprites, which never z-fight. Their batched
 * replacement is coplanar with the plan geometry, so it needs lifting too.
 */
export const FLOORPLAN_LABEL_Z_OFFSET = 0.03

/**
 * Lifts rip/lintel labels above the other labels of their storey. They are placed
 * at the storey top (the slab level); the lift keeps them strictly above the slab
 * labels there instead of coplanar with them, so the depth test resolves in their
 * favour. The PDF export writes the lintel and rip annotations after the slab
 * annotations (see `add_bluebeam_annotations`), so the scene stacks them on top
 * the same way.
 */
export const POSITION_LABEL_Z_LIFT = 0.01

/**
 * Gap between a rip/lintel and its label, matching `PLAN_LABEL_GAP_WORLD` in
 * the export plan models (`ripV2.py` / `lintelV2.py`).
 */
export const PLAN_LABEL_GAP_WORLD = 0.05

/**
 * Footprint size a column falls back to when it has no cross section, matching
 * the `Rips2DMesh` default the toolkit draws it with.
 */
export const DEFAULT_COLUMN_CROSS_SECTION_SIZE = 0.2

/**
 * `WALL_ASSEMBLY_TEXT_COLOR_HEX` of the PDF export: the stiffening plan's wall labels (the wall
 * assembly) are black for inner and outer walls alike.
 */
export const STIFFENING_PLAN_WALL_LABEL_COLOR = '#000000'

/** `STIFFENING_SEGMENT_COLOR_HEX` of the PDF export, the stiffening segment label text */
export const STIFFENING_SEGMENT_LABEL_COLOR = '#378435'

/** `ANCHOR_COLOR_HEX` of the PDF export: the Zuganker and Schubanker labels' text and border */
export const STIFFENING_PLAN_ANCHOR_LABEL_COLOR = '#0000FF'

/**
 * `ANCHOR_PLOT_DISTANCE` of the stiffening plan export: a Zuganker label sits this far (in world
 * meters) inside the segment from the segment end it anchors.
 */
export const TENSILE_ANCHOR_LABEL_DISTANCE_WORLD = 0.25

/**
 * The export writes the anchor labels after the segment footprints and labels, so the scene
 * stacks them on top of the segment labels (which sit at the storey top).
 */
export const STIFFENING_PLAN_ANCHOR_LABEL_Z_LIFT = 0.01

/**
 * `WALL_THICKNESS_WORLD` of the export's `ExportPositionPlanSegment` footprint, which is what the
 * Schubanker label's distance from the segment axis is measured from (not the wall's structural
 * thickness).
 */
export const EXPORT_SEGMENT_WALL_THICKNESS_WORLD = 0.1

/** `SHEAR_ANCHOR_LABEL_MARGIN_POINTS`: paper gap between the drawn wall and the Schubanker label */
export const SHEAR_ANCHOR_LABEL_MARGIN_PT = 2
